
import BreadcrumbsWithSchema from "./SEO/BreadcrumbsWithSchema";

interface PageBreadcrumbProps {
  items?: Array<{
    label: string;
    path?: string;
  }>;
  customLabels?: Record<string, string>;
  className?: string;
}

/**
 * PageBreadcrumb - Breadcrumb navigation with structured data
 * 
 * This component is a simple wrapper around BreadcrumbsWithSchema to maintain
 * backwards compatibility with existing code while providing improved SEO.
 */
const PageBreadcrumb = (props: PageBreadcrumbProps) => {
  return <BreadcrumbsWithSchema {...props} />;
};

export default PageBreadcrumb;
